/**
 * Shared regular expressions.
 *
 * Anything with the `g` flag carries `lastIndex` state between calls, so use
 * those only with `String.replace`, which always starts at 0. Never `.test()`
 * a shared global regex — consecutive calls give alternating answers.
 */

// Strips everything that is not a digit: phone numbers, OTP boxes, pasted codes.
export const NON_DIGIT_REGEX = /\D/g;

// A complete SMS verification code, as issued for login and step-up.
export const SIX_DIGIT_CODE_REGEX = /^\d{6}$/;
